import React, { useEffect, useState } from 'react'
import { useFirebaseApp, useFirestoreDoc } from 'reactfire'
import { Grid, RadioButton } from 'grommet'

export default function ShowPreference(props) {
  const { enabled, group, preference, userID } = props

  const firebaseApp = useFirebaseApp()
  const preferencesRef = firebaseApp
    .firestore()
    .collection(userID)
    .doc('preferences')
  const preferencesDoc = useFirestoreDoc(preferencesRef)
  const preferencesObject = preferencesDoc.data()

  const currentPreference = preferencesObject[group][preference] || 'medium'

  const [selected, setSelected] = useState(currentPreference)

  // eslint-disable-next-line
  const updatePreference = (value) => {
    preferencesRef.update({
      [group]: {
        ...preferencesObject[group],
        [preference]: value
      }
    })
  }

  // const valueToSave = (value) =>
  //   value === 'disabled' ? 0 : value === 'low' ? 50 : value === 'medium' ? 100 : 150

  useEffect(() => {
    if (!enabled) {
      updatePreference('disabled')
      setSelected('disabled')
    }
  }, [enabled, updatePreference])

  const handleClick = (e) => {
    const { value } = e.target
    setSelected(value)

    updatePreference(value)
  }
  return (
    <Grid
      columns={{
        count: 3,
        size: 'auto'
      }}
      gap="small"
    >
      {['low', 'medium', 'high'].map((choice) => (
        <RadioButton
          key={choice}
          direction="row"
          disabled={!enabled}
          label={choice}
          name={props.preference}
          value={choice}
          checked={selected === choice}
          onChange={(e) => handleClick(e)}
        />
      ))}
    </Grid>
  )
}
